export default "__VITE_ASSET__CqqEpjuE__"